const getters = {
  isLoggedIn: state => state.isLoggedIn,
  isLoading: state => state.isBootstrapLoading,
  clients: state => state.data && state.data.clients,
  currentUser: state => state.data && state.data.current_user,
  currentClient: state => state.currentClient,
  currentClientConfig: state => state.currentClientConfig,
  transporterNonGst: state => state.data && state.data.gst && state.data.gst.TRANSPORTER_NON_GST,
  currentTransporter: state => state.data && state.data.transporter,
  depots: state => state.data && state.data.depots,
  getOtherDepots: state => state.data && state.data.otherDepots,
  cities: state => state.data && state.data.cities,
  indentCustomFields: state => state.data && state.data.indent_custom_fields,
  indentSourceCustomFields: state => state.data && state.data.indent_source_custom_fields,
  indentDestinationCustomFields: state => state.data && state.data.indent_destination_custom_fields,
  inspection: state => state.data && state.data.inspection,
  inspectionDocs: state => state.data && state.data.inspection_documents,
  inspectionAtDestination: state => state.data && state.data.inspection_at_destination,
  inspectionDocsAtDestination: state => state.data && state.data.inspection_documents_at_destination,
  showTermsDialog: state => state && state.showTermsDialog,
  data: state => state && state.data,
  environmentVariables: state => state && state.environmentVariables,
  mdmBoostrap: state => state.mdmBoostrap,
  filterVisibility: state => state.hideFilter,
  getIsPaymentError: state => state.isPaymentError,
};

export default getters;
